// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoRegular_89cccc', '__robotoRegular_Fallback_89cccc'","fontWeight":400},"className":"__className_89cccc","variable":"__variable_89cccc"};